import ResponsiveHeader from '@/components/ResponsiveHeader';
import { Stack } from 'expo-router';
import { Image, Pressable } from 'react-native';

export default function PurchasedCoursesLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ navigation, options, back }) => (
          <ResponsiveHeader
            title={(options.title as string) || ''}
            showBack={!!back}
            showBookmark={true}
            onBack={() => navigation.goBack()}
            navItems={[
              { label: 'Explore', href: '/explore' },
              { label: 'Live', href: '/live' },
              { label: 'The Hang', href: '/library' },
            ]}
            right={
              <Pressable onPress={() => { /* open profile */ }} hitSlop={8}>
                <Image
                  source={{ uri: 'https://placehold.co/32x32' }}
                  style={{ width: 28, height: 28, borderRadius: 14, backgroundColor: '#555' }}
                />
              </Pressable>
            }
          />
        ),
      }}
    >
      <Stack.Screen name="index" options={{ title: '' }} />
      <Stack.Screen name="all" options={{ title: 'Purchased Courses' }} />
    </Stack>
  );
}
